import PATH from 'routes/path';

const BasicNavList = [
  {
    title: 'Products',
    path: `${PATH.PRODUCTS}`
  },
  {
    title: 'Resources',
    path: `${PATH.RESOURCES}`
  },
  {
    title: 'Services',
    path: `${PATH.SERVICES}`
  },
  {
    title: 'Locations',
    path: `${PATH.LOCATIONS}`
  },
  {
    title: 'Careers',
    path: `${PATH.CAREERS}`
  },
  {
    title: 'Support',
    path: `${PATH.SUPPORT}`
  }
];

export default BasicNavList;
